import React from 'react'
import Input from './Input'
import RightBarGroup from './RightBarGroup'
import MarginOptions from './MarginOptions'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  jsonCopy,
  LogoSectionData,
  LogoSectionLogo,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<LogoSectionData>
  setData: (e: ChangeEvent<LogoSectionLogo[] | string>) => void
}

const LogoSectionEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  const onChange = (
    e: ChangeEvent<FileEntryBM | string>,
    i: number,
    key: keyof LogoSectionLogo
  ) => {
    const updated = jsonCopy(content.data)
    if (key === 'image') {
      updated.logos[i].image = e.target.value as FileEntryBM
    } else {
      updated.logos[i][key] = e.target.value as string
    }
    const updateEvent = {
      target: {
        name: 'logos',
        value: updated.logos,
      },
    }
    setData(updateEvent)
  }

  return (
    <>
      {content.data.logos.map((_card, i) => (
        <React.Fragment key={`logoSection_edit_${content.uuid}_${i}`}>
          <RightBarGroup title={`${tr(TrKey.logoSectionEditorLogo)} #${i + 1}`}>
            <Input
              type='image'
              setter={(f) =>
                onChange({ target: { name: 'logos', value: f } }, i, 'image')
              }
              value={content.data.logos[i].image}
            />
            <Input
              light
              label={tr(TrKey.logoSectionEditorCompanyName)}
              id={`logoSection_edit_h_${i}`}
              value={content.data.logos[i].name}
              onChange={(e) => onChange(e, i, 'name')}
            />
            <Input
              light
              label={tr(TrKey.logoSectionEditorLink)}
              id={`logoSection_edit_btnhref_${i}`}
              value={content.data.logos[i].link}
              onChange={(e) => onChange(e, i, 'link')}
            />
          </RightBarGroup>
        </React.Fragment>
      ))}
      <MarginOptions content={content} setData={setData} />
    </>
  )
}

export default LogoSectionEditor
